module.exports = "<svg id=Слой_1 data-name=\"Слой 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 122 122\"> <defs> <style>.cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px}</style> </defs> <circle class=\"cls-1 svg-light\" cx=61 cy=61 r=34 /> <path id=center class=svg-light d=M73.55,63.13c2-1.17,2-3.09,0-4.26l-18-10.37c-2-1.17-3.69-.21-3.69,2.13V71.37c0,2.34,1.66,3.3,3.69,2.13Z /> </svg>";


//////////////////
// WEBPACK FOOTER
// ./public/web/images/play_krug-01.svg
// module id = wwrt
// module chunks = 3 4